import type { HTMLAttributes } from 'react'
import { cx } from './cx'
import styles from './Row.module.css'

interface RowProps extends HTMLAttributes<HTMLDivElement> {
  /** Table header: muted background, tighter padding. Compose with Eyebrow-styled text. */
  header?: boolean
}

/** List row inside a Card. The last row has no bottom border. */
export function Row({ header, className, ...rest }: RowProps) {
  return <div {...rest} className={cx(styles.row, header && styles.header, className)} />
}
